import type { MyLikesState } from './types';

const initialState: MyLikesState = {
  likesSent: [],
  likesSentLoaded: false,
  likesSentLoading: false,
  nextPageToken: null,
};

export default initialState;
